import { render, staticRenderFns } from "./DocumentsVersionDialog.vue?vue&type=template&id=19bb1e35"
import script from "./DocumentsVersionDialog.vue?vue&type=script&lang=ts"
export * from "./DocumentsVersionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports